import { Heart, Users, Sparkles } from "lucide-react";
import { useT } from "@/i18n";

const Welcome = () => {
  const t = useT(
    {
      heading: "Herzlich Willkommen",
      intro:
        "In meiner Praxis finden Sie vor allem individuelle Begleitung bei wiederkehrenden, chronischen und komplexen Beschwerden – mit besonderem Fokus auf ganzheitliche Zusammenhänge.",
      features: [
        { icon: Heart, label: "Empathie & Zeit" },
        { icon: Users, label: "Ganzheitlicher Ansatz" },
        { icon: Sparkles, label: "Fachliches Know-How" },
      ],
    },
    {
      heading: "A Warm Welcome",
      intro:
        "In my practice you will find individual support especially for recurring, chronic and complex complaints – with a special focus on holistic connections.",
      features: [
        { icon: Heart, label: "Empathy & Time" },
        { icon: Users, label: "A Holistic Approach" },
        { icon: Sparkles, label: "Professional Expertise" },
      ],
    },
  );

  return (
    <section id="willkommen" className="py-12 md:py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">{t.heading}</h2>
          <p className="text-lg text-muted-foreground leading-relaxed">{t.intro}</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 p-8 rounded-xl bg-card border border-border text-center sm:text-left">
            {t.features.map((feature) => (
              <div key={feature.label} className="flex items-center gap-3">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary shrink-0">
                  <feature.icon className="w-6 h-6" />
                </div>
                <span className="text-base font-medium text-foreground">{feature.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
